export default __webpack_public_path__ + "static/media/text-img-01.b592448a.svg";